// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plain block instead of ion-content: the modal is sized to its content (see global.scss),
   and an absolutely positioned ion-content would collapse to zero height there.
   The safe-area padding keeps it readable on devices with a notch when the dialog is full screen. */
.content {
  display: block;
  padding-top: var(--ion-safe-area-top, 0px);
  padding-bottom: var(--ion-safe-area-bottom, 0px);
  padding-left: var(--ion-safe-area-left, 0px);
  padding-right: var(--ion-safe-area-right, 0px);
  background: var(--ion-background-color, #fff);
}

.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 20px 20px;
  gap: 6px;
}
.popup-body .header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-primary);
  margin-bottom: 4px;
}
.popup-body .header-icon ion-icon {
  font-size: 32px;
}
.popup-body .title {
  margin: 4px 0 0;
  font-weight: 600;
}
.popup-body .message {
  margin: 0 0 12px;
  color: var(--ion-color-medium);
  font-size: 14px;
}
.popup-body .options {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}
.popup-body .option-card {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  text-align: start;
  background: var(--ion-item-background, var(--ion-background-color, #fff));
  color: var(--ion-text-color);
  border: 2px solid var(--ion-color-step-150, #e0e0e0);
  border-radius: 14px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, transform 0.1s ease;
}
.popup-body .option-card:hover {
  border-color: rgba(var(--ion-color-primary-rgb), 0.5);
}
.popup-body .option-card:active {
  transform: scale(0.99);
}
.popup-body .option-card:focus-visible {
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.3);
}
.popup-body .option-card .option-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  overflow: hidden;
  filter: grayscale(0.35);
  opacity: 0.85;
  transition: filter 0.15s ease, opacity 0.15s ease, transform 0.15s ease;
}
.popup-body .option-card .option-logo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.popup-body .option-card .option-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  gap: 2px;
}
.popup-body .option-card .option-name {
  font-weight: 600;
  font-size: 16px;
}
.popup-body .option-card .option-description {
  font-size: 13px;
  color: var(--ion-color-medium);
}
.popup-body .option-card .option-check {
  display: flex;
  flex: 0 0 auto;
  color: var(--ion-color-primary);
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.popup-body .option-card .option-check ion-icon {
  font-size: 26px;
}
.popup-body .option-card.selected {
  border-color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.06);
  box-shadow: 0 4px 14px rgba(var(--ion-color-primary-rgb), 0.18);
}
.popup-body .option-card.selected .option-logo {
  filter: none;
  opacity: 1;
  transform: scale(1.04);
}
.popup-body .option-card.selected .option-check {
  opacity: 1;
  transform: scale(1);
}
.popup-body .actions-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
  margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-select-integration/popup-select-integration.component.scss"],"names":[],"mappings":"AAAA;;oGAAA;AAGA;EACE,cAAA;EACA,0CAAA;EACA,gDAAA;EACA,4CAAA;EACA,8CAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,+BAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;AACN;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,8BAAA;EACA,eAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,yEAAA;EACA,4BAAA;EACA,oDAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,4GACE;AALN;AAUI;EACE,qDAAA;AARN;AAWI;EACE,sBAAA;AATN;AAYI;EACE,6DAAA;AAVN;AAaI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,uEACE;AAZR;AAgBM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAdR;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,QAAA;AAhBN;AAmBI;EACE,gBAAA;EACA,eAAA;AAjBN;AAoBI;EACE,eAAA;EACA,8BAAA;AAlBN;AAqBI;EACE,aAAA;EACA,cAAA;EACA,+BAAA;EACA,UAAA;EACA,qBAAA;EACA,oDACE;AApBR;AAuBM;EACE,eAAA;AArBR;AAyBI;EACE,sCAAA;EACA,oDAAA;EACA,+DAAA;AAvBN;AAyBM;EACE,YAAA;EACA,UAAA;EACA,sBAAA;AAvBR;AA0BM;EACE,UAAA;EACA,mBAAA;AAxBR;AA6BE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AA3BJ","sourcesContent":["/* Plain block instead of ion-content: the modal is sized to its content (see global.scss),\n   and an absolutely positioned ion-content would collapse to zero height there.\n   The safe-area padding keeps it readable on devices with a notch when the dialog is full screen. */\n.content {\n  display: block;\n  padding-top: var(--ion-safe-area-top, 0px);\n  padding-bottom: var(--ion-safe-area-bottom, 0px);\n  padding-left: var(--ion-safe-area-left, 0px);\n  padding-right: var(--ion-safe-area-right, 0px);\n  background: var(--ion-background-color, #fff);\n}\n\n.popup-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 24px 20px 20px;\n  gap: 6px;\n\n  .header-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n    color: var(--ion-color-primary);\n    margin-bottom: 4px;\n\n    ion-icon {\n      font-size: 32px;\n    }\n  }\n\n  .title {\n    margin: 4px 0 0;\n    font-weight: 600;\n  }\n\n  .message {\n    margin: 0 0 12px;\n    color: var(--ion-color-medium);\n    font-size: 14px;\n  }\n\n  .options {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 10px;\n  }\n\n  .option-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    width: 100%;\n    padding: 14px 16px;\n    text-align: start;\n    background: var(--ion-item-background, var(--ion-background-color, #fff));\n    color: var(--ion-text-color);\n    border: 2px solid var(--ion-color-step-150, #e0e0e0);\n    border-radius: 14px;\n    cursor: pointer;\n    outline: none;\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease,\n      background-color 0.15s ease,\n      transform 0.1s ease;\n\n    &:hover {\n      border-color: rgba(var(--ion-color-primary-rgb), 0.5);\n    }\n\n    &:active {\n      transform: scale(0.99);\n    }\n\n    &:focus-visible {\n      box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.3);\n    }\n\n    .option-logo {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 auto;\n      width: 48px;\n      height: 48px;\n      border-radius: 12px;\n      overflow: hidden;\n      filter: grayscale(0.35);\n      opacity: 0.85;\n      transition:\n        filter 0.15s ease,\n        opacity 0.15s ease,\n        transform 0.15s ease;\n\n      img {\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n    }\n\n    .option-text {\n      display: flex;\n      flex-direction: column;\n      flex: 1 1 auto;\n      min-width: 0;\n      gap: 2px;\n    }\n\n    .option-name {\n      font-weight: 600;\n      font-size: 16px;\n    }\n\n    .option-description {\n      font-size: 13px;\n      color: var(--ion-color-medium);\n    }\n\n    .option-check {\n      display: flex;\n      flex: 0 0 auto;\n      color: var(--ion-color-primary);\n      opacity: 0;\n      transform: scale(0.6);\n      transition:\n        opacity 0.15s ease,\n        transform 0.15s ease;\n\n      ion-icon {\n        font-size: 26px;\n      }\n    }\n\n    &.selected {\n      border-color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.06);\n      box-shadow: 0 4px 14px rgba(var(--ion-color-primary-rgb), 0.18);\n\n      .option-logo {\n        filter: none;\n        opacity: 1;\n        transform: scale(1.04);\n      }\n\n      .option-check {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n  }\n\n  .actions-row {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    gap: 10px;\n    margin-top: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
